export {default as ParcelOrderViewPage} from './parcel-order-view';